<template>
  <base-message-page title="Questionario inoltrato" message="Grazie per la collaborazione. ;)" />
</template>

<script>
import BaseMessagePage from '@/components/BaseMessagePage.vue'

export default {
  components: {
    BaseMessagePage,
  },
}
</script>
